document.addEventListener('DOMContentLoaded', function () {
  checkWaitForReviewsCountCards();
  checkWaitForReviewsCountPDP();

  let scrollTimeout = null;
  window.addEventListener('scroll', () => {
    clearTimeout(scrollTimeout);

    scrollTimeout = setTimeout(() => {
      const currentTarget = document.querySelector('#ProductGridContainer .collection');
      if (currentTarget) {
        checkWaitForReviewsCountCards();
      }
    }, 500); // this setTimeout is extremely necessary - delay needed to wait for infinite scroll to inject new DOM elements
  });
});

function checkWaitForReviewsCountCards() {
  let targetSelector = '[data-bv-show=inline_rating] .bv_main_container .bv_averageRating_component_container .bv_text';
  waitForReviewsCount(targetSelector)
    .then((reviewsCount) => {
      Array.from(reviewsCount).forEach((el) => {
        let _counter = parseFloat(el.innerText);
        if (_counter <= 0) {
          let container = el.closest('[data-bv-show=inline_rating]');
          container.style.visibility = 'hidden';
        }
      });
    })
    .catch((error) => {
      console.error('Failed to find reviewsCount:', error);
    });
}

function checkWaitForReviewsCountPDP() {
  let targetSelector = '[data-bv-show=rating_summary] .bv_main_container .bv_ratings_summary .bv_numReviews_text';
  waitForReviewsCount(targetSelector)
    .then((reviewsCount) => {
      Array.from(reviewsCount).forEach((el) => {
        let _counter = parseFloat(el.innerText.replace(/[()]/g, ''));
        if (_counter <= 0) {
          let container = el.closest('.bv_ratings_summary');
          container.style.setProperty('display', 'none', 'important');
          document.querySelector('div[data-bv-show=reviews]').style.display = 'none';
        }
      });
    })
    .catch((error) => {
      console.error('Failed to find reviewsCount:', error);
    });
}

function waitForReviewsCount(targetSelector) {
  return new Promise((resolve, reject) => {
    let reviews = document.querySelectorAll(targetSelector);
    if (reviews.length > 0) {
      resolve(reviews);
      return;
    }

    let observer = new MutationObserver((mutations, obs) => {
      let found = document.querySelectorAll(targetSelector);
      if (found.length > 0) {
        obs.disconnect();
        resolve(found);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}
